"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6206],{

/***/ 6206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Footer_Footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/icons/FacebookIcon.tsx

var FacebookIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: "0",
        viewBox: "0 0 320 512",
        height: "1em",
        width: "1em",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
        })
    });
};
/* harmony default export */ var icons_FacebookIcon = (FacebookIcon);

;// CONCATENATED MODULE: ./src/icons/InstagramIcon.tsx

var InstagramIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: "0",
        viewBox: "0 0 24 24",
        height: "1em",
        width: "1em",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M17.3183118,0.0772036939 C18.5358869,0.132773211 19.3775594,0.311686093 20.156489,0.614412318 C20.9357539,0.917263935 21.5259307,1.30117806 22.1124276,1.88767349 C22.6988355,2.47414659 23.0827129,3.06422396 23.3856819,3.84361655 C23.688357,4.62263666 23.8672302,5.46418415 23.9227984,6.68172489 C23.9916356,8.19170553 24,8.72394829 24,11.9999742 C24,15.2760524 23.9916355,15.808302 23.9227954,17.3182896 C23.8672306,18.5358038 23.6883589,19.3773584 23.3855877,20.1566258 C23.0826716,20.9358162 22.6987642,21.5259396 22.1124276,22.1122749 C21.5259871,22.6987804 20.9357958,23.0827198 20.1563742,23.3856323 C19.3772192,23.6883583 18.5357324,23.8672318 17.3183209,23.9227442 C15.8086874,23.9916325 15.2765626,24 12,24 C8.72343739,24 8.19131258,23.9916325 6.68172382,23.9227463 C5.46426077,23.8672314 4.62270711,23.6883498 3.84342369,23.3855738 C3.0641689,23.0827004 2.47399369,22.6987612 1.88762592,22.1123283 C1.30117312,21.525877 0.91721975,20.9357071 0.614318116,20.1563835 C0.311643016,19.3773633 0.132769821,18.5358159 0.0772038909,17.3183251 C0.0083529426,15.8092887 0,15.2774634 0,11.9999742 C0,8.7225328 0.00835296697,8.19071076 0.0772047368,6.68165632 C0.132769821,5.46418415 0.311643016,4.62263666 0.614362729,3.84350174 C0.91719061,3.06430165 1.30113536,2.4741608 1.88757245,1.88772514 C2.47399369,1.30123879 3.0641689,0.917299613 3.84345255,0.614414972 C4.62236201,0.311696581 5.46409415,0.132773979 6.68163888,0.0772035898 C8.19074867,0.00835221992 8.72252573,0 12,0 C15.2774788,0 15.8092594,0.00835235053 17.3183118,0.0772036939 Z M12,2.66666667 C8.75959504,2.66666667 8.26400713,2.67445049 6.80319929,2.74109814 C5.87614637,2.78341009 5.31952221,2.90172878 4.80947575,3.09995521 C4.37397765,3.26922052 4.09725505,3.44924273 3.77324172,3.77329203 C3.44916209,4.09737087 3.26913181,4.37408574 3.09996253,4.80937168 C2.90169965,5.31965737 2.78340891,5.87618164 2.74109927,6.80321713 C2.67445122,8.26397158 2.66666667,8.75960374 2.66666667,11.9999742 C2.66666667,15.2403924 2.67445121,15.7360281 2.74109842,17.1967643 C2.78340891,18.1238184 2.90169965,18.6803426 3.09990404,19.1904778 C3.26914133,19.6259017 3.44919889,19.9026659 3.77329519,20.2267614 C4.09725505,20.5507573 4.37397765,20.7307795 4.80932525,20.8999863 C5.31971515,21.0982887 5.87621193,21.2165784 6.80323907,21.2588497 C8.26460439,21.3255353 8.76051223,21.3333333 12,21.3333333 C15.2394878,21.3333333 15.7353956,21.3255353 17.1968056,21.2588476 C18.123775,21.216579 18.6802056,21.0982995 19.1905083,20.9000309 C19.6260288,20.7307713 19.9027426,20.5507596 20.2267583,20.226708 C20.5507492,19.9027179 20.7308046,19.6259456 20.9000375,19.1906283 C21.0983009,18.6803412 21.2165908,18.1238118 21.2588986,17.196779 C21.3255376,15.7350718 21.3333333,15.2390126 21.3333333,11.9999742 C21.3333333,8.76098665 21.3255376,8.26493375 21.2589016,6.80323567 C21.2165911,5.87618164 21.0983004,5.31965737 20.9001178,4.80957831 C20.7308131,4.37403932 20.550774,4.09729207 20.2267583,3.77324038 C19.9027658,3.44924868 19.6260264,3.26922777 19.1905015,3.09996643 C18.6803988,2.90171817 18.1238378,2.78341062 17.1967608,2.74109868 C15.7359966,2.67445057 15.2404012,2.66666667 12,2.66666667 Z M12,18.2222222 C8.56356156,18.2222222 5.77777778,15.4364384 5.77777778,12 C5.77777778,8.56356156 8.56356156,5.77777778 12,5.77777778 C15.4364384,5.77777778 18.2222222,8.56356156 18.2222222,12 C18.2222222,15.4364384 15.4364384,18.2222222 12,18.2222222 Z M12,15.5555556 C13.9636791,15.5555556 15.5555556,13.9636791 15.5555556,12 C15.5555556,10.0363209 13.9636791,8.44444444 12,8.44444444 C10.0363209,8.44444444 8.44444444,10.0363209 8.44444444,12 C8.44444444,13.9636791 10.0363209,15.5555556 12,15.5555556 Z M18.2222222,7.11111111 C17.4858426,7.11111111 16.8888889,6.51415744 16.8888889,5.77777778 C16.8888889,5.04139811 17.4858426,4.44444444 18.2222222,4.44444444 C18.9586019,4.44444444 19.5555556,5.04139811 19.5555556,5.77777778 C19.5555556,6.51415744 18.9586019,7.11111111 18.2222222,7.11111111 Z"
        })
    });
};
/* harmony default export */ var icons_InstagramIcon = (InstagramIcon);

;// CONCATENATED MODULE: ./src/icons/LinkedInIcon.tsx

var LinkedInIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: "0",
        version: "1.1",
        viewBox: "0 0 16 16",
        height: "1em",
        width: "1em",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 6h2.767v1.418h0.040c0.385-0.691 1.327-1.418 2.732-1.418 2.921 0 3.461 1.818 3.461 4.183v4.817h-2.885v-4.27c0-1.018-0.021-2.329-1.5-2.329-1.502 0-1.732 1.109-1.732 2.255v4.344h-2.883v-9z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 6h3v9h-3v-9z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 3.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
            })
        ]
    });
};
/* harmony default export */ var icons_LinkedInIcon = (LinkedInIcon);

;// CONCATENATED MODULE: ./src/icons/MailUnderlineIcon.tsx

var MailUnderlineIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: "0",
        viewBox: "0 0 512 512",
        height: "1em",
        width: "1em",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "M320 96H88a40 40 0 00-40 40v240a40 40 0 0040 40h334.73a40 40 0 0040-40V239"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "M112 160l144 112 87-65.67"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "431.95",
                cy: "128.05",
                r: "47.95"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M432 192a63.95 63.95 0 1163.95-63.95A64 64 0 01432 192zm0-95.9a32 32 0 1031.95 32 32 32 0 00-31.95-32z"
            })
        ]
    });
};
/* harmony default export */ var icons_MailUnderlineIcon = (MailUnderlineIcon);

// EXTERNAL MODULE: ./public/imgs/lotties/get_in_touch_lottie.json
var get_in_touch_lottie = __webpack_require__(20356);
// EXTERNAL MODULE: ./public/imgs/lotties/heart-lootie.json
var heart_lootie = __webpack_require__(8042);
// EXTERNAL MODULE: ./public/imgs/lotties/mail_lottie.json
var mail_lottie = __webpack_require__(38988);
// EXTERNAL MODULE: ./public/imgs/lotties/message-lottie.json
var message_lottie = __webpack_require__(3971);
// EXTERNAL MODULE: ./public/imgs/lotties/telephone-lootie.json
var telephone_lootie = __webpack_require__(62674);
// EXTERNAL MODULE: ./public/imgs/lotties/telephone_lottie.json
var telephone_lottie = __webpack_require__(15797);
// EXTERNAL MODULE: ./node_modules/react-lazy-load/dist/LazyLoad.js
var LazyLoad = __webpack_require__(25043);
// EXTERNAL MODULE: ./src/constant/index.tsx + 38 modules
var constant = __webpack_require__(17089);
;// CONCATENATED MODULE: ./src/icons/Logos/WhiteLongLogo.tsx


var WhiteLongLogo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 1736 295",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M209.135 85.1286C223.126 85.1286 232.534 75.962 232.534 63.4182C232.534 51.8394 223.126 43.1553 209.135 43.1553C195.144 43.1553 185.736 52.3219 185.736 64.1419C185.736 75.962 195.144 85.1286 209.135 85.1286ZM190.319 233H227.951V103.22H190.319V233ZM361.055 103.22V119.865C351.164 107.321 336.208 101.291 318.116 101.291C282.174 101.291 253.227 126.137 253.227 164.009C253.227 201.882 282.174 226.728 318.116 226.728C335.002 226.728 349.234 221.421 359.125 210.566V216.114C359.125 239.513 347.546 251.574 321.011 251.574C304.366 251.574 286.275 245.785 275.178 236.86L260.222 263.877C275.419 275.697 299.301 281.728 323.906 281.728C370.704 281.728 396.756 259.535 396.756 211.29V103.22H361.055ZM325.594 195.851C305.814 195.851 291.34 183.066 291.34 164.009C291.34 144.953 305.814 132.168 325.594 132.168C345.375 132.168 359.607 144.953 359.607 164.009C359.607 183.066 345.375 195.851 325.594 195.851ZM450.596 85.1286C464.588 85.1286 473.995 75.962 473.995 63.4182C473.995 51.8394 464.588 43.1553 450.596 43.1553C436.605 43.1553 427.198 52.3219 427.198 64.1419C427.198 75.962 436.605 85.1286 450.596 85.1286ZM431.781 233H469.412V103.22H431.781V233ZM577.911 200.193C573.81 203.329 568.262 205.018 562.714 205.018C552.582 205.018 546.552 198.987 546.552 187.891V135.062H578.876V106.115H546.552V74.5146H508.92V106.115H488.899V135.062H508.92V188.373C508.92 219.25 526.771 234.93 557.407 234.93C568.986 234.93 580.323 232.276 588.042 226.728L577.911 200.193ZM661.513 101.291C640.767 101.291 619.781 106.839 605.548 116.97L619.057 143.264C628.465 135.786 642.697 131.203 656.447 131.203C676.71 131.203 686.359 140.611 686.359 156.773H656.447C616.886 156.773 600.724 172.694 600.724 195.61C600.724 218.044 618.816 234.93 649.21 234.93C668.267 234.93 681.776 228.658 688.771 216.838V233H723.99V158.944C723.99 119.624 701.074 101.291 661.513 101.291ZM658.618 209.601C645.35 209.601 637.39 203.329 637.39 193.921C637.39 185.237 642.938 178.724 660.548 178.724H686.359V191.992C682.017 203.812 671.162 209.601 658.618 209.601ZM758.048 233H795.679V54.0104H758.048V233ZM1015.67 195.369C1005.78 200.676 995.893 202.606 985.279 202.606C952.955 202.606 930.521 180.172 930.521 148.571C930.521 116.488 952.955 94.5364 985.762 94.5364C1002.89 94.5364 1017.12 100.567 1029.42 113.593L1054.51 90.4355C1038.11 71.3787 1013.5 61.2472 983.832 61.2472C930.038 61.2472 890.96 97.6723 890.96 148.571C890.96 199.47 930.038 235.895 983.108 235.895C1007.23 235.895 1032.8 228.417 1051.37 214.426V145.917H1015.67V195.369ZM1120.96 120.348V103.22H1085.02V233H1122.65V171.729C1122.65 146.882 1136.4 135.545 1157.15 135.545C1160.04 135.545 1162.46 135.786 1165.59 136.027V101.291C1145.57 101.291 1130.13 107.804 1120.96 120.348ZM1313.92 168.593C1313.92 126.861 1284.49 101.291 1246.37 101.291C1206.81 101.291 1177.14 129.273 1177.14 168.11C1177.14 206.706 1206.33 234.93 1251.2 234.93C1274.6 234.93 1292.69 227.693 1304.75 213.943L1284.73 192.233C1275.8 200.676 1265.91 204.777 1252.16 204.777C1232.38 204.777 1218.63 194.886 1215.01 178.724H1313.19C1313.43 175.588 1313.92 171.487 1313.92 168.593ZM1246.61 129.755C1263.5 129.755 1275.8 140.369 1278.46 156.773H1214.53C1217.18 140.128 1229.49 129.755 1246.61 129.755ZM1437.15 103.22V119.865C1427.26 107.321 1412.3 101.291 1394.21 101.291C1358.27 101.291 1329.32 126.137 1329.32 164.009C1329.32 201.882 1358.27 226.728 1394.21 226.728C1411.1 226.728 1425.33 221.421 1435.22 210.566V216.114C1435.22 239.513 1423.64 251.574 1397.1 251.574C1380.46 251.574 1362.37 245.785 1351.27 236.86L1336.32 263.877C1351.51 275.697 1375.39 281.728 1400 281.728C1446.8 281.728 1472.85 259.535 1472.85 211.29V103.22H1437.15ZM1401.69 195.851C1381.91 195.851 1367.43 183.066 1367.43 164.009C1367.43 144.953 1381.91 132.168 1401.69 132.168C1421.47 132.168 1435.7 144.953 1435.7 164.009C1435.7 183.066 1421.47 195.851 1401.69 195.851ZM1606.05 103.22V119.865C1596.16 107.321 1581.21 101.291 1563.11 101.291C1527.17 101.291 1498.23 126.137 1498.23 164.009C1498.23 201.882 1527.17 226.728 1563.11 226.728C1580 226.728 1594.23 221.421 1604.12 210.566V216.114C1604.12 239.513 1592.54 251.574 1566.01 251.574C1549.36 251.574 1531.27 245.785 1520.18 236.86L1505.22 263.877C1520.42 275.697 1544.3 281.728 1568.9 281.728C1615.7 281.728 1641.75 259.535 1641.75 211.29V103.22H1606.05ZM1570.59 195.851C1550.81 195.851 1536.34 183.066 1536.34 164.009C1536.34 144.953 1550.81 132.168 1570.59 132.168C1590.37 132.168 1604.61 144.953 1604.61 164.009C1604.61 183.066 1590.37 195.851 1570.59 195.851Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1676.9 197.9H1712.59V233H1676.9V197.9Z",
                fill: "#C10206"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 232.937H76.585C131.736 232.937 169.547 199.632 169.547 148.469C169.547 97.3048 131.736 64 76.585 64H36.1854V99.1952H0V232.937ZM74.1766 99.1952C107.652 99.1952 130.05 116.129 130.05 148.469C130.05 180.808 108.134 200.839 74.6583 200.839L36.1854 201.252V99.1952H74.1766Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var Logos_WhiteLongLogo = (WhiteLongLogo);

// EXTERNAL MODULE: ./src/icons/Logos/BlackLongLogo.tsx
var BlackLongLogo = __webpack_require__(17626);
;// CONCATENATED MODULE: ./src/components/Footer/Footer.tsx
/* eslint-disable @next/next/no-img-element */ 
















var Lottie = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9185)]).then(__webpack_require__.bind(__webpack_require__, 69185));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69185)
            ];
        }
    }
});




function Footer() {
    var ref = (0,react.useState)({
        teliphone: false,
        mail: false,
        getIn: false
    }), play = ref[0], setPlay = ref[1];
    var router = (0,next_router.useRouter)();
    var isBlogPage = router.pathname === "/insights";
    var isBlogPages = router.pathname.includes("/insights");
    var phoneCall = function() {
        router.push("tel:".concat(atob(constant/* encPhone */.gQ)));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "w-full ".concat(isBlogPage && "bg-secondary text-white"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return window.scrollTo(0, 0);
                },
                className: "hidden cursor-pointer ml-auto text-red bg-primary h-[200px] lg:flex items-center justify-center w-[70px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "-rotate-90 -translate-y-10 relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-white font-primary text-[14px] -translate-x-[350%] inline-block relative top-[1px]",
                            children: "Top"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "inline-block w-[70px] h-0.5 bg-white -translate-x-full absolute top-1/2 left-[150%] rotate-180 _bottomToTop"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:hidden h-[70px] w-2.5 bg-primary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "order-2 lg:order-none w-[70px] shrink-0 ".concat(isBlogPages ? "lg:bg-redblack bg-primary" : "bg-primary"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-redblack lg:hidden w-full flex items-center justify-center aspect-square",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/contact-us",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[27px] cursor-pointer text-white transition ease-in-out duration-300",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_MailUnderlineIcon, {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "text-white py-2 lg:py-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "text-2xl lg:text-[27px] flex items-center justify-center py-3 lg:py-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: constant/* facebookUrl */.cm,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            "aria-label": "facebook link",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "transition ease-in-out duration-300 ".concat(isBlogPages ? "lg:hover:text-primary" : "lg:hover:text-redblack"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_FacebookIcon, {})
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "text-2xl lg:text-[27px] flex items-center justify-center py-3 lg:py-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: constant/* instagramUrl */.TG,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            "aria-label": "instragram link",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "transition ease-in-out duration-300  ".concat(isBlogPages ? "lg:hover:text-primary" : "lg:hover:text-redblack"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_InstagramIcon, {})
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "text-2xl lg:text-[27px] flex items-center justify-center py-3 lg:py-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: constant/* linkedinUrl */.ET,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            "aria-label": "linkedin link",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "transition ease-in-out duration-300  ".concat(isBlogPages ? "lg:hover:text-primary" : "lg:hover:text-redblack"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_LinkedInIcon, {})
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "order-1 lg:order-none grow grid grid-cols-1 lg:grid-cols-[2fr,3fr,3fr] lg:gap-[20px] xl:gap-[100px] justify-center pl-[30px] lg:pl-[70px] xl:pl-[140px] lg:pt-[45px] pt-[20px] pb-5 lg:pb-[70px] w-full ".concat(isBlogPage ? "bg-secondary" : "bg-white"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[208px] mb-6 lg:mb-0 flex items-start",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "#",
                                        "aria-label": "home page",
                                        children: isBlogPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos_WhiteLongLogo, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackLongLogo/* default */.Z, {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-6 lg:mb-0 lg:ml-8 xl:ml-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "",
                                    children: constant/* footerMiddleItems.map */.lS.map(function(param, i) {
                                        var lists = param.lists, title = param.title;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "font-bold text-[13px] leading-[20px]  mb-5 lg:mb-4 ".concat(isBlogPage ? "text-white" : "text-black"),
                                                    children: title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: "space-y-3 footer-middle-list",
                                                    children: lists.map(function(param, i) {
                                                        var text = param.text, url = param.url;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            className: "max-w-[250px] lg:w-auto",
                                                            children: i === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: url,
                                                                "aria-label": text,
                                                                className: "text-[14px] leading-[20px] ".concat(isBlogPage ? "text-white" : "text-[#5A5A5A]"),
                                                                target: "_blank",
                                                                rel: "noreferrer",
                                                                children: text
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-[14px] leading-[20px] ".concat(isBlogPage ? "text-white" : "text-[#5A5A5A]"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: url,
                                                                    children: text
                                                                })
                                                            })
                                                        }, "gdafd_" + i);
                                                    })
                                                })
                                            ]
                                        }, "dgfas_" + i);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "lg:space-y-3 space-y-1.5 hidden lg:block",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: "#",
                                            // href={`tel:${tel}`}
                                            "aria-label": "phone call",
                                            className: "flex items-center gap-6 group cursor-pointer w-max",
                                            onClick: phoneCall,
                                            onMouseEnter: function() {
                                                setPlay(function(prev) {
                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                        teliphone: true
                                                    });
                                                });
                                            },
                                            onMouseLeave: function() {
                                                setPlay(function(prev) {
                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                        teliphone: false
                                                    });
                                                });
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "scale-[1.15]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lottie, {
                                                            animationData: isBlogPage ? telephone_lootie : telephone_lottie,
                                                            play: play.teliphone,
                                                            speed: 0.5,
                                                            className: "w-[40px] h-[40px]",
                                                            loop: play.teliphone
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "inline-block font-semibold text-[1.14286rem] leading-[20px] group-hover:text-primary transition ease-in-out duration-300",
                                                    children: "Call by Phone"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/contact-us",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "#",
                                                "aria-label": "contact page",
                                                className: "flex items-center gap-6 group cursor-pointer w-max",
                                                onMouseEnter: function() {
                                                    setPlay(function(prev) {
                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                            mail: true
                                                        });
                                                    });
                                                },
                                                onMouseLeave: function() {
                                                    setPlay(function(prev) {
                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                            mail: false
                                                        });
                                                    });
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "scale-[1.15]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lottie, {
                                                                animationData: isBlogPage ? message_lottie : mail_lottie,
                                                                play: play.mail,
                                                                speed: 0.5,
                                                                className: "w-[40px] h-[40px]",
                                                                loop: play.mail
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "inline-block font-semibold text-[1.14286rem] leading-[20px] group-hover:text-primary transition ease-in-out duration-300",
                                                        children: "Message Us"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/request-estimate",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "#",
                                                "aria-label": "request estimate page",
                                                className: "flex items-center gap-6 group w-max",
                                                onMouseEnter: function() {
                                                    setPlay(function(prev) {
                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                            getIn: true
                                                        });
                                                    });
                                                },
                                                onMouseLeave: function() {
                                                    setPlay(function(prev) {
                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                            getIn: false
                                                        });
                                                    });
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "scale-[1.15]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lottie, {
                                                                animationData: isBlogPage ? heart_lootie : get_in_touch_lottie,
                                                                play: play.getIn,
                                                                speed: 0.5,
                                                                className: "w-[40px] h-[40px]",
                                                                loop: play.getIn
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "inline-block font-semibold text-[1.14286rem] leading-[20px] group-hover:text-primary transition ease-in-out duration-300",
                                                        children: "Get Started"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "justify-between items-center hidden lg:flex px-[70px] py-12 ".concat(isBlogPages ? "bg-redblack" : "bg-primary"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] leading-[20px] shrink-0 text-white tracking-[0.07em] w-[30%] xl:30%",
                        children: "\xa92023. Digital Gregg LLC. All rights reserved."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "pr-5 xl:pr-[60px] grow flex justify-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "flex items-center justify-end gap-[26px] xl:gap-8 xl:justify-between xl:w-[90%]",
                            children: constant/* footerNavigationsItems.map */.pT.map(function(param, i) {
                                var path = param.path, text = param.text;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: path,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "#",
                                            "aria-label": "".concat(text, " page'"),
                                            className: "'leading-[20px] text-[1.14286rem] text-white tracking-[0.03em]  transition ease-in-out duration-300 hover:opacity-70",
                                            children: text
                                        })
                                    })
                                }, "dgasdg_" + i);
                            })
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Footer_Footer = (Footer);

;// CONCATENATED MODULE: ./src/components/Footer/index.tsx




/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ })

}]);